/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QuizQuestionAnswerDto,
    QuizQuestionAnswerDtoFromJSON,
    QuizQuestionAnswerDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuizQuestionDto
 */
export interface QuizQuestionDto {
    /**
     * 
     * @type {number}
     * @memberof QuizQuestionDto
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof QuizQuestionDto
     */
    text: string;
    /**
     * 
     * @type {Array<QuizQuestionAnswerDto>}
     * @memberof QuizQuestionDto
     */
    answers?: Array<QuizQuestionAnswerDto> | null;
}

export function QuizQuestionDtoFromJSON(json: any): QuizQuestionDto {
    return {
        'number': json['number'],
        'text': json['text'],
        'answers': !exists(json, 'answers') ? undefined : (json['answers'] as Array<any>).map(QuizQuestionAnswerDtoFromJSON),
    };
}

export function QuizQuestionDtoToJSON(value?: QuizQuestionDto | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'number': value.number,
        'text': value.text,
        'answers': value.answers === undefined ? undefined : (value.answers as Array<any>).map(QuizQuestionAnswerDtoToJSON),
    };
}


